class CookieAuth {
  /**
   * Set the authentication cookie with the JWT token
   * @param {string} jwtToken 
   * @param {string} cookieName 
   */
  static setAuthCookie(jwtToken, cookieName = 'avetta_auth') {
    try {
      if (!jwtToken) {
        console.warn('[CookieAuth] No JWT token provided');
        return;
      }

      const cookieValue = encodeURIComponent(jwtToken);
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      const domain = isLocalhost ? 'localhost' : '.avetta.com';
      const path = '/';
      const secure = window.location.protocol === 'https:';
      const sameSite = 'Lax';
      
      let cookieString = `${cookieName}=${cookieValue};path=${path};SameSite=${sameSite}`;
      

      if (!isLocalhost) {
        cookieString += `;domain=${domain}`;
      }
      
      if (secure) {
        cookieString += ';Secure';
      }
      
      // Set the cookie
      document.cookie = cookieString;
      
    } catch (error) {
      console.error('[CookieAuth] Failed to set authentication cookie:', error);
    }
  }

  /**
   * Remove the authentication cookie
   * @param {string} cookieName - The name of the cookie to remove
   */
  static removeAuthCookie(cookieName = 'avetta_auth') {
    try {
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      const domain = isLocalhost ? 'localhost' : '.avetta.com';
      const path = '/';
      const expiredDate = new Date(0).toUTCString();
      
      let cookieString = `${cookieName}=;path=${path};expires=${expiredDate}`;
      
      if (!isLocalhost) {
        cookieString += `;domain=${domain}`;
      }

      if (window.location.protocol === 'https:') {
        cookieString += ';Secure';
      }
                    
      document.cookie = cookieString;
      
    } catch (error) {
      console.error('[CookieAuth] Failed to remove authentication cookie:', error);
    }
  }

  /**
   * Get the authentication cookie value
   * @param {string} cookieName 
   * @returns {string|null}
   */
  static getAuthCookie(cookieName = 'avetta_auth') {
    try {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) {
          return decodeURIComponent(value);
        }
      }
      return null;
    } catch (error) {
      console.error('[CookieAuth] Failed to get authentication cookie:', error);
      return null;
    }
  }

  /**
   * Checking if the authentication cookie exists
   * @param {string} cookieName 
   * @returns {boolean} 
   */
  static hasAuthCookie(cookieName = 'avetta_auth') {
    return this.getAuthCookie(cookieName) !== null;
  }

  static #REDIRECT_COOKIE = 'avetta_auth_redirect';

  static #isAllowedRedirectUrl(url) {
    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname;
      return hostname === 'localhost'
        || hostname === '127.0.0.1'
        || hostname.endsWith('.avetta.com');
    } catch {
      return false;
    }
  }

  static getAndClearRedirectUrl() {
    const raw = this.getAuthCookie(this.#REDIRECT_COOKIE);
    if (!raw) return null;

    this.removeAuthCookie(this.#REDIRECT_COOKIE);

    if (!this.#isAllowedRedirectUrl(raw)) return null;
    return raw;
  }

  static #LOGOUT_SIGNAL_COOKIE = 'avetta_logout';

  static getAndClearLogoutSignal() {
    const signal = this.getAuthCookie(this.#LOGOUT_SIGNAL_COOKIE);
    if (!signal) return false;

    this.removeAuthCookie(this.#LOGOUT_SIGNAL_COOKIE);
    return true;
  }
}

export { CookieAuth as default };

